export default "__VITE_ASSET__DXrjkEFI__"